import { Component, OnInit, ElementRef } from '@angular/core';
import { SiteInfosService, WindowRefService, LangueService } from '@app/core';
import { IComment } from '@app/shared';
@Component({
    selector: 'app-comments',
    templateUrl: './comments.component.html',
    styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit {

    comments: Array<IComment> = [];
    bookingNoteMin: number;
    tripadvisorNoteMin: number;

    constructor(private siteInfosService: SiteInfosService, private winRef: WindowRefService, private el: ElementRef, private langueService: LangueService) { }

    ngOnInit() {
        this.comments = this.siteInfosService.getCommentByLang(this.winRef.appConfigSite.defaultlangue);
        this.langueService.changeLangSubject.subscribe(
            (langue: string) => {
                this.comments = this.siteInfosService.getCommentByLang(langue);
            }
        )
        this.bookingNoteMin = (this.siteInfosService.getEtabData()['sBookingMinNote'] != null) ? this.siteInfosService.getEtabData()['sBookingMinNote'] : 7;
        this.tripadvisorNoteMin = (this.siteInfosService.getEtabData()['sTripAdvisorMinNote'] != null) ? this.siteInfosService.getEtabData()['sTripAdvisorMinNote'] : 3;
        //TODO: change langue - for checkprice site
    }

    showComment(idComment) {
        this.el.nativeElement.querySelector(".comment_" + idComment).classList.add("show");
    }

    hideComment(idComment) {
        this.el.nativeElement.querySelector(".comment_" + idComment).classList.remove("show");
    }

}
